export const BASIC = 'BASIC';
export const BLACK = 'BLACK';
export const SUB = 'SUB';
export const PLACEHOLDER = 'PLACEHOLDER';
export const TEXT_BUTTON = 'TEXT_BUTTON';
export const ERROR = 'ERROR';
export const DISABLED = '#ddd';
export const BLUE = '#6191ff';
export const WHITE = 'WHITE';
